export function buildStarkKeysTypedData(ethereumChainId: number) {
  return {
    domain: {
      name: 'Paradex',
      chainId: ethereumChainId,
      version: '1',
    },
    primaryType: 'Constant',
    types: {
      EIP712Domain: [
        { name: 'name', type: 'string' },
        { name: 'version', type: 'string' },
        { name: 'chainId', type: 'uint256' },
      ],
      Constant: [{ name: 'action', type: 'string' }],
    },
    message: {
      action: 'STARK Key',
    },
  } as const;
}
